import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import type { Params } from "@/types";
import type { ScheduleNotificationTemplate } from "@/types/schedules";

const endpoint = {
  notificationsSchedule: "/notifications-schedule",
};

export const fetchNotificationsSchedule = createAsyncThunk(
  "notificationsSchedule/fetch",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.notificationsSchedule, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const createNotificationsSchedule = createAsyncThunk(
  "notificationsSchedule/create",
  async (payload: Omit<ScheduleNotificationTemplate, "id">, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.notificationsSchedule,
        payload,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const updateNotificationsSchedule = createAsyncThunk(
  "notificationsSchedule/update",
  async (
    payload: Partial<ScheduleNotificationTemplate> & { id: number },
    thunkAPI,
  ) => {
    try {
      const { id, ...body } = payload;
      const response = await axiosInstance.put(
        `${endpoint.notificationsSchedule}/${id}`,
        body,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const deleteNotificationsSchedule = createAsyncThunk(
  "notificationsSchedule/delete",
  async (id: number, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.notificationsSchedule}/${id}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);
